import { render, staticRenderFns } from "./smschannel.vue?vue&type=template&id=62ec31ab&"
import script from "./smschannel.vue?vue&type=script&lang=js&"
export * from "./smschannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports